// extracted by mini-css-extract-plugin
export default {"title":"SectionTitle_title__d12JZ","swoosh":"SectionTitle_swoosh__-uKAl"};